define('models/Podio.Models.Comment',['require','underscore','jquery','lib/backbone/Backbone.PodioModel','lib/Podio.Routes','collections/Podio.Collections.Files','collections/Podio.Collections.Questions','models/Podio.Models.User','models/Podio.Models.Embed','models/Podio.Models.File'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioModel = require('lib/backbone/Backbone.PodioModel');
  var routes = require('lib/Podio.Routes');

  return PodioModel.extend({

    has_many: function() {
      return {
        'files': require('collections/Podio.Collections.Files'),
        'questions': require('collections/Podio.Collections.Questions')
      };
    },

    has_one: function() {
      return {
        'created_by': require('models/Podio.Models.User'),
        'embed': require('models/Podio.Models.Embed'),
        'embed_file': require('models/Podio.Models.File')
      };
    },

    like: function(options) {
      var requestData = { value: 1 };
      if (options) {
        requestData = _.extend(options, requestData);
      }
      return this.request('post', routes.rating_path('comment', this.get('id') , 'like', requestData ));
    },

    unlike: function(options) {
      var requestData = { value: 1 };
      if (options) {
        requestData = _.extend(options, requestData);
      }
      return this.request('delete', routes.rating_path('comment', this.get('id') , 'like', requestData ));
    },

    deleteComment: function(options) {
      return this.request('delete', routes.comment_path(this.get('id'), options), {});
    },

    getLikeCount: function() {
      return this.request('get', routes.ratings_like_count_path('comment', this.get('id')));
    },

    getAllLikes: function() {
      return this.request('get', routes.ratings_all_likes_path('comment', this.get('id')));
    },

    getById: function(commentId) {

      var dfd = new $.Deferred();

      // Get comment and add to collection.
      var req = this.request('get', routes.comment_path(commentId), {
        variant: 'json'
      });

      var self = this;
      req.done(_.bind(function(responseData) {
        self.set(JSON.parse(responseData.data.comment), {silent:true});
        dfd.resolve(self);
      }, this));

      return dfd;

    },

    create: function(options) {
      options = options || {variant: 'json', alert_invite: false};
      var self = this;
      var requestData = _.extend(options, {comment: self.toJSON()});
      var url = routes.comments_path({commentable_type: self.get('ref')['type'], commentable_id: self.get('ref')['id']});

      var req = this.request('post', url, requestData);

      req.done(function(responseData) {
        if (responseData.status === 'ok') {
          self.trigger('commentCreated', responseData);
        }
      });

      return req;
    }

  });

});

